import React from 'react';
import './App.css';
import './Court.css';
import { MdOutlineCameraAlt } from "react-icons/md";

import { useNavigate } from "react-router-dom";

class CourtList extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			locationID: 0,
			courtArray: null,
			cameraArray: null,
		}
	}
		
	componentDidMount() {
		var locationID = this.props.locationID;
		this.serverGetCourtList(locationID);
		var companyID = this.props.companyID;
	}

	componentDidUpdate() {
		
		var locationID1 = this.state.locationID;
		var locationID2 = this.props.locationID;
		
		if (locationID1 !== locationID2) {
			this.refreshData(locationID2);
			this.setState({
				locationID: locationID2,
			});
		}

		var refreshCourtListYN = this.props.refreshCourtListYN;
		if (refreshCourtListYN) {
			this.refreshData(locationID1);
			this.props.setRefreshCourtListYN(false);
		}
	}
	
	refreshData(locationID) {
		this.serverGetCourtList(locationID);
		this.serverGetCameraListByLocationID(locationID);
	}

	async serverGetCourtList(locationID) {
		
		if (locationID <= 0) {
			return;
		}

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/getcourtlist?locationid=" + locationID;
		
		var courtArray = null;
		
		try {
			var res = await fetch(url);
			courtArray = await res.json();
		} catch (err) {
			console.error(err);
		}
		
		this.setState({
			courtArray: courtArray,
		});
	}
	
	async serverGetCameraListByLocationID(locationID) {
		
		if (locationID <= 0) {
			return;
		}

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/getcameralistbylocationid?locationid=" + locationID;
		
		var cameraArray = null;
		
		try {
			var res = await fetch(url);
			cameraArray = await res.json();
		} catch (err) {
			console.error(err);
		}
		
		this.setState({
			cameraArray: cameraArray,
		});
	}
	
	findItemInCameraJPGArray(cameraID1) {

		var cameraJPGArray = this.props.cameraJPGArray;
		var i;
		var itemObj2;
		var cameraID2;
		var foundYN = false;

		for(i=0; i<cameraJPGArray.length; i++) {
			itemObj2 = cameraJPGArray[i];
			cameraID2 = itemObj2.cameraID;
			if (cameraID1 === cameraID2) {
				return itemObj2;
			}
		}
		
		return null;
	}

	handleSelectCourt(courtID) {
		this.props.setSelectedCourt(courtID);
		const navigate = this.props.navigate;
  		navigate("/court");
	}
	
	handleCameraIconTouchStart(courtID, cameraID) {
	}

	handleCameraIconTouchEnd(courtID, cameraID) {
		this.props.setSelectedCourt(courtID);
		this.props.setSelectedCamera(cameraID);
		const navigate = this.props.navigate;
  		navigate("/stream");
	}

	handleCameraIconMouseDown(courtID, cameraID) {
		this.handleCameraIconTouchStart(courtID, cameraID);
	}

	handleCameraIconMouseUp(courtID, cameraID) {
		this.handleCameraIconTouchEnd(courtID, cameraID);
	}

	renderOneCameraJpg(courtIndex, cameraIndex, courtID, cameraID) {

		var itemObj = this.findItemInCameraJPGArray(cameraID);
		if (itemObj === null) {
			return null;
		}
		
		var jpgBase64 = itemObj.jpgBase64;
		var unixTimeSec = itemObj.unixTimeSec;

		var byteCharacters = atob(jpgBase64);
		var byteNumbers = new Array(byteCharacters.length)
			.fill(0)
			.map((_, i) => byteCharacters.charCodeAt(i));
		var jpgBuffer = new Uint8Array(byteNumbers);

		var blob = new Blob([jpgBuffer], { type: "image/jpeg" });
		var url = URL.createObjectURL(blob);
		
		var timestampString = this.props.getTimeStringFromUnixTimeSec(unixTimeSec);
	
		var key = "camera-" + courtIndex + "-" + cameraIndex;
		return (
			<div key={key} className="CourtListOneCamera" onClick={() => this.handleSelectCourt(courtID)}>
				<img className="CourtListOneImage" width="300px" src={url}/>
				<div className="CourtListOneTimestamp">{timestampString}</div>
			</div>
		);
	}
	
	renderAllCameraJpgsForOneCourt(courtIndex, courtID1) {
		
		var cameraArray = this.state.cameraArray;
		var key = "cameraholder-" + courtIndex;
		var i;
		var itemObj;
		var courtID2;
		var cameraID;
		var jsxCode;
		var jsxArray = [];
		
		for(i=0; i<cameraArray.length; i++) {
			itemObj = cameraArray[i];
			courtID2 = itemObj.courtID;
			if (courtID1 === courtID2) {
				cameraID = itemObj.cameraID;
				jsxCode = this.renderOneCameraJpg(courtIndex, i, courtID1, cameraID);
				jsxArray.push(jsxCode);
			}
		}
		
		return (
			<div key={key} className="CourtListBoxCameraContainer">
				{jsxArray}
			</div>
		);
	}
	
	renderOneCameraIcon(courtIndex, cameraIndex, courtID, cameraID) {

		var key = "camera-" + courtIndex + "-" + cameraIndex;
		return (
			<div key={key} className="CourtListOneCameraIcon" 
				onTouchStart={() => this.handleCameraIconTouchStart(courtID, cameraID)} 
				onTouchEnd={() => this.handleCameraIconTouchEnd(courtID, cameraID)} 
				onMouseDown={() => this.handleCameraIconMouseDown(courtID, cameraID)} 
				onMouseUp={() => this.handleCameraIconMouseUp(courtID, cameraID)} 
			>
				<MdOutlineCameraAlt style={{ padding: "5px", color: "black", width: "25px", height: "25px" }} />
			</div>
		);
	}

	renderAllCameraIconsForOneCourt(courtIndex, courtID1) {
		
		// temp
		/*var email = this.props.email;		
		if ((email !== "niksa.radovic@zizipickleball.hr") && (email !== "niksa.radovic@padelcentarsplit.com")) {
			return null;
		}*/

		var cameraArray = this.state.cameraArray;
		var key = "cameraholder-" + courtIndex;
		var i;
		var itemObj;
		var courtID2;
		var cameraID;
		var jsxCode;
		var jsxArray = [];
		
		for(i=0; i<cameraArray.length; i++) {
			itemObj = cameraArray[i];
			courtID2 = itemObj.courtID;
			if (courtID1 === courtID2) {
				cameraID = itemObj.cameraID;
				jsxCode = this.renderOneCameraIcon(courtIndex, i, courtID1, cameraID);
				jsxArray.push(jsxCode);
			}
		}
		
		return (
			<div key={key} className="CourtListBoxCameraIconContainer">
				{jsxArray}
			</div>
		);
	}
	
	renderOneCourt(index, itemObj) {

		var key = "box-" + index;
		var courtID = itemObj.courtID;
		var courtName = itemObj.courtName;
		var jsxCodeAllCameraIcons = this.renderAllCameraIconsForOneCourt(index, courtID);
		var jsxCodeAllCameraJpgs = this.renderAllCameraJpgsForOneCourt(index, courtID);
		
		return (
			<div key={key} className="CourtListOneBox">
				<div className="CourtListOneBoxTopLine">
					<div className="CourtListBoxTitle" onClick={() => this.handleSelectCourt(courtID)}>{courtName}</div>
					{jsxCodeAllCameraIcons}
				</div>
				{jsxCodeAllCameraJpgs}
			</div>
		);
	}

	renderAllCourts() {
		
		var i;
		var itemObj;
		var jsxCode;
		var jsxArray = [];
		var courtArray = this.state.courtArray;
		
		for(i=0; i<courtArray.length; i++) {
			itemObj = courtArray[i];
			jsxCode = this.renderOneCourt(i, itemObj);
			jsxArray.push(jsxCode);
		}
		
		return (
			<div className="CourtListBoxContainer">
				{jsxArray}
			</div>
		);
	}

	render() {

		var courtArray = this.state.courtArray;
		if (courtArray === null) {
			return;
		}
		
		var cameraArray = this.state.cameraArray;
		if (cameraArray === null) {
			return;
		}
		
		return (
			<div className="CourtListTopContainer">
				{this.renderAllCourts()}
				<div style={{height: "10px"}}></div>
			</div>
		);
	}
}

export default function CourtListFunction(props) {
	const navigate = useNavigate();
	return <CourtList {...props} navigate={navigate} />;
}

